import {useEffect} from "react";
import { Howl, Howler } from 'howler';

import BellSound from "../../../assets/audio/bell.mp3";
import BellSoundOgg from "../../../assets/audio/bell.ogg";

export default function OrderSoundPlayer({ isSoundEnabled }) {
  const commonSoundProps = {
    src: [BellSound, BellSoundOgg],
    autoplay: false,
    loop: false
  };
  const loopInterval = 2000
  let loopIntervalId = null
  let suspendedStateCaptured = false

  const testSoundInstance = new Howl({
    ...commonSoundProps,
    volume: 0,
    onend: () => console.info('order sound test played successfully'),
    onloaderror: (id, err) => onSoundFailed(err),
    onplayerror: (id, err) => onSoundFailed(err)
  })

  const loopSoundInstance = new Howl({
    ...commonSoundProps,
    onloaderror: (id, err) => console.log(`order sound player load error: ${err}`),
    onplayerror: (err) => console.log(`order sound player play error: ${err}`)
  })

  useEffect(() => {
    testSoundInstance.play()
    playOrderSoundLoop()

    return () => {
      clearPlayerSoundInterval()
    }
  })

  function onSoundFailed() {
    console.log('failed to play order sound test')
  }

  function clearPlayerSoundInterval() {
    if (loopIntervalId) clearInterval(loopIntervalId);
  }

  function playOrderSoundLoop() {
    if (!isSoundEnabled) return

    clearPlayerSoundInterval()

    if (Howler.ctx.state === 'suspended' && !suspendedStateCaptured) {
      console.log('order sound player suspended state')
      suspendedStateCaptured = true
    }

    loopSoundInstance.play()

    loopIntervalId = setTimeout(playOrderSoundLoop, loopInterval)
  }

  return null
}
